// extracted by mini-css-extract-plugin
export default {"container":"TagSnp__container___bWynN"};